<template>
  <page>
    <div class="m-grid__item m-grid__item--fluid m-wrapper">

      <!-- BEGIN: Subheader -->
      <div class="m-subheader ">
        <div class="d-flex align-items-center">
          <div class="mr-auto">
            <h1 class="m-subheader__title ">Polityka prywatności</h1>
          </div>
        </div>
      </div>
      <!-- END: Subheader -->
      <div class="m-content m-content-ls">
        <div class="m-portlet m-portlet--full-height">
          <div class="m-portlet__body">
            <div class="row">
              <div class="col-sm-12">
                <privacy-policy-content></privacy-policy-content>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </page>
</template>

<script>
import Encode from "@/directives/encode";
import Page from "./Page";
import PrivacyPolicyContent from "../content/PrivacyPolicyContent";
import {mapActions, mapState} from "vuex";
import {PRIVACY_POLICY} from "@/utils/PageModalTypes";

export default {
  name: "PrivacyPolicyPage",
  components: {PrivacyPolicyContent, Page},
  directives: {Encode},
  beforeMount() {
    if (!this.isAuthorized) {
      this.setPageModal({
        show: true,
        type: PRIVACY_POLICY,
        title: 'Polityka prywatności',
        content: ''
      });

      this.logout();
    }
  },
  methods: mapActions([
    'setPageModal',
    'logout'
  ]),
  computed: mapState({
    isAuthorized: state => state.auth.isAuthorized
  })
}
</script>

<style>
.m-content-ls a {
  color: var(--accent-color) !important;
}
</style>
